import api from './';

export default {
    /**
     * Get credit limits
     * @param params
     */
    get(params) {
        return api
            .get('/creditLimits', {
                params: params,
            })
            .then((response) => {
                return response.data;
            });
    },
};
